import React, { memo } from 'react';
import isNil from 'ramda/src/isNil';
import CheckIcon from '@components/@core/CheckIcon';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';

const CourseHeader = () => (
    <div className="career-required-instances">
        <div className="quotas">
            <div className="d-none d-sm-flex list py-2 desktop-screen">
                <div className="d-flex-8">
                    <div className="dsl-m12">Course</div>
                </div>
                <div className="d-flex-2">
                    <div className="dsl-m12">Modules</div>
                </div>
                <div className="d-flex-3">
                    <div className="dsl-m12">Time Lock</div>
                </div>
                <div className="d-flex-2">
                    <div className="dsl-m12">Status</div>
                </div>
                <div className="d-flex-1"></div>
            </div>
        </div>
    </div>
);

function Course({ data, role, edit = false, onMenu, onSelect }) {
    const onClickCourse = (course, type) => {};
    const dotsMenu = ['Move Up', 'Move Down', 'Remove'];
    return (
        <div className="lib-programs-career mt-3">
            <div className="border-bottom pt-3 mb-4">
                <CourseHeader />
                {data?.length > 0 ? (
                    <>
                        {data.map((item, index) => {
                            const name = item.name || item.data.name;
                            const description = item.data.description;
                            const thumbnail = item.data.thumb_url;
                            const modules = item.children?.length;
                            const status = item.completed_at;

                            return (
                                <div className="library-course-card p-0" onClick={() => onClickCourse(0, 'course')}>
                                    <div className={`lib-content d-flex ssm-column training-course ${index === 0 && 'border-0'}`} onClick={() => onMenu('preview view', item)}>
                                        <div className="module-content d-flex d-flex-1">
                                            <div className="d-flex-8 d-flex">
                                                <CheckIcon className="mr-3" size={26} checked={!isNil(status)} onClick={() => onClickCourse(0, 'course')} />
                                                <Thumbnail source={thumbnail} />
                                                <div className="d-none d-sm-block px-3">
                                                    <p className="dsl-b16 text-400 mb-0 truncate-one">{name}</p>
                                                    <div className="dsl-b16 w-100 truncate-one mb-0" dangerouslySetInnerHTML={{ __html: description }} />
                                                </div>
                                            </div>

                                            <div className="mobile-block d-flex-2 mt-3">
                                                <p className="dsl-b16 mb-0">
                                                    <span>Name:</span>
                                                    <span className="dsl-b16 text-400">{name}</span>
                                                </p>
                                            </div>
                                            <div className="d-flex-2">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Modules:</span> {modules}
                                                </p>
                                            </div>
                                            <div className="d-flex-3">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Time Lock:</span> Immediately available
                                                </p>
                                            </div>
                                            <div className="d-flex-2">
                                                <p className="dsl-b16 mb-0">
                                                    <span className="mobile-screen">Status:</span> {!isNil(status) ? 'Completed' : 'Incomplete'}
                                                </p>
                                            </div>
                                            <div className="d-flex-1">{edit && <EditDropdown options={dotsMenu} onChange={(e) => onSelect(e, item)} />}</div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : (
                    <p className="dsl-b16 py-4 mb-0">No Courses Attached</p>
                )}
            </div>
        </div>
    );
}

export default memo(Course);
